"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _key = require("b2b-components/utils/key");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function TopBarDropdown(_ref) {
  var linksGroups = _ref.linksGroups,
    onLinkClick = _ref.onLinkClick;
  if (!Array.isArray(linksGroups) || !linksGroups.length) {
    return null;
  }
  var handleLinkClick = function handleLinkClick(href) {
    return function (event) {
      onLinkClick(href, event);
      event.preventDefault();
    };
  };
  var renderGroup = function renderGroup(_ref2) {
    var name = _ref2.name,
      links = _ref2.links;
    if (!Array.isArray(links) || !links.length) {
      return null;
    }
    if (links.length === 1) {
      var link = links[0];
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: (0, _key.createKey)(link.title)
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: link.href,
        className: "cds-TopBar-Link",
        onClick: handleLinkClick(link.href)
      }, link.title));
    }
    var dropdownLinks = links.map(function (_ref3) {
      var title = _ref3.title,
        href = _ref3.href;
      return {
        onClick: function onClick() {
          onLinkClick(href);
        },
        title: title
      };
    });
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (0, _key.createKey)(name)
    }, /*#__PURE__*/_react["default"].createElement(_Dropdown.Dropdown, {
      links: dropdownLinks,
      isHoverable: true,
      className: "cds-TopBar-DropDropdown",
      tooltipWrapperClassName: "cds-TopBar-Tooltip",
      togglerProps: {
        label: name,
        className: 'cds-TopBar-Dashboard-Toggler'
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-TopBar-Section cds-TopBar-Section--NavLinks"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-List cds-List--Unstyled cds-List--Inline"
  }, linksGroups.map(renderGroup)));
}
var MemoizedTopBarDropdown = /*#__PURE__*/(0, _react.memo)(TopBarDropdown);
exports.TopBarDropdown = MemoizedTopBarDropdown;